export default __webpack_public_path__ + "static/media/signupImage.e2b35106.webp";